import React from 'react'
import { GoX } from 'react-icons/go'


export default function Modal({open, onClose, children}) {
    
  return (
    <div onClick={onClose} 
    className={` bg-black/50 fixed inset-0 flex z-[100] justify-center rounded-lg items-center transition-colors  ${open ? "visible bg-black/20": "invisible"}`}>
      <div onClick={(e)=> e.stopPropagation()} className={`bg-white  w-max   rounded-xl fixed shadow  transition-all ${open ? "scale-90 md:scale-100 opacity-100": "scale-125 opacity-0"}`}>
        <button onClick={onClose} className='fixed top-2 right-2 p-1 rounded-lg text-gray-400  bg-white hover:bg-gray-50  hover:text-gray-600'>
             < GoX size={30}/>
        </button> 
        {children}
      </div>
    </div>
  )
}
